import React, { useEffect, useState } from 'react';

import { AudienceSegmentActiveActive, IAudienceSegment } from '~/src/dash/api/console-api';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';

interface IAudienceSegmentSelectProps {
  name: string;
  onChange: (elem: React.ChangeEvent) => void;
  audienceSegments: IAudienceSegment[];
  publisherID: string;
  value: string;
  disabled?: boolean;
  helperText?: string;
  menuTitleOverride?: string;
}

export const AudienceSegmentTargetingMultiSelect = function ({
  onChange,
  disabled,
  name,
  audienceSegments,
  publisherID,
  value = '',
  helperText,
  menuTitleOverride,
}: IAudienceSegmentSelectProps) {
  const [audienceSegmentMenuList, setAudienceSegmentMenuList] = useState<IMenuList>({});
  useEffect(() => {
    setAudienceSegmentMenuList(buildAudienceSegmentMenuList(audienceSegments, value));
  }, [publisherID]);

  function handleMenuSelectionDone(values: IMenuList) {
    const segmentIdStringIDs = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);

    const selectedSegments = audienceSegments.filter((audienceSegment) =>
      segmentIdStringIDs.includes(audienceSegment.ID.toString()),
    );

    onChange({
      target: {
        name,
        value: selectedSegments
          .map((audienceSegment: IAudienceSegment) => audienceSegment.ID)
          .join(','),
      },
    } as any);
  }

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={true}
      menuTitle='Audience Segments'
      menuTitleOverride={menuTitleOverride}
      list={audienceSegmentMenuList}
      disabled={disabled}
      onChange={setAudienceSegmentMenuList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      helperText={helperText}
    />
  );
};

function buildAudienceSegmentMenuList(
  audienceSegments: IAudienceSegment[],
  audienceTargeting: string,
): IMenuList {
  const list = {} as IMenuList;
  const selectedIDs = audienceTargeting.split(',');

  audienceSegments.forEach((audienceSegment) => {
    list[audienceSegment.ID] = {
      title:
        audienceSegment.Active === AudienceSegmentActiveActive
          ? audienceSegment.Name
          : `${audienceSegment.Name} [inactive]`,
      ID: String(audienceSegment.ID),
      selected: selectedIDs.includes(audienceSegment.ID),
    } as IListItem;
  });
  return list;
}
